<div class="flex-center">
	<wyzeweb-link-list
		[type]="LIST_TYPE.COLUMN"
		[links]="contentStore.filterLinksByGroup(SITE_LINK.CONTACT)"
		[fontModifier]="FONT_MODIFIER.BASE"></wyzeweb-link-list>
</div>
